export default __webpack_public_path__ + "static/P_SearchThumb_MobileRouter-73986eaa2dc0d135e6812a084b6bd83f.webp";